<div class="text-center col-12 col-md-8 mx-auto my-2 border border-dark rounded">
    <div class="d-flex justify-content-center flex-wrap">
        
        <div class="w-100 d-flex justify-content-center mx-2 py-2 flex-wrap ">
            <img src="../../../assets/images/n2xgo.png" alt="" style="height:50px;">
            <span class="w-100 text-center py-1" style="font-size:1.5rem">
                <strong>Money Transfer Ready to Pay</strong>
            </span>
            <span class="w-100 text-center py-1">
                Your N2XGo transfer has been approved and is ready to pay. 
            </span>
            <span class="w-100 text-center py-1">
                Authorization no. <strong>{{ sendMoneyService.qr_code }}</strong>
            </span>
            <hr class="col-11 col-md-9 border-dark">
            <div class="w-100 py-1 d-flex ">
                <div class="col-6 text-center">Reciever</div>
                <div class="col-6 text-center">{{sendMoneyService.receiver?.payee_name}}</div>
            </div>
            <div class="w-100 py-1 d-flex ">
                <div class="col-6 text-center">Payment Method</div>
                <div class="col-6 text-center">Cash At Location</div>
            </div>
            <div class="w-100 py-1 d-flex ">
                <div class="col-6 text-center">Send Amount </div>
                <div class="col-6 text-center">{{sendMoneyService.transactionDetails.sending_amt}}</div>
            </div>
            <div class="w-100 py-1 d-flex ">
                <div class="col-6 text-center">Receive Amount</div>
                <div class="col-6 text-center">{{sendMoneyService.transactionDetails.send_amt}}</div>
            </div>
            <div class="w-100 py-1 d-flex ">
                <div class="col-6 text-center">Fees</div>
                <div class="col-6 text-center">{{sendMoneyService.transactionDetails.fee_amount}}</div>
            </div>
            <div class="w-100 py-1 d-flex ">
                <div class="col-6 text-center"></div>
                <div class="col-6 text-center"><hr class="col-6 border-dark"></div>
            </div>
            <div class="w-100 py-1 d-flex ">
                <div class="col-6 text-center">Total Amount</div>
                <div class="col-6 text-center">{{ amount }}</div>
            </div>
            <hr class="col-11 col-md-9 border-dark">
            <span class="w-100 text-center">
               Please follow the steps below to complete your transfer:
            </span>
            <span class="col-12 col-md-9 text-left d-flex flex-wrap fs-14 px-2">
                <span class="w-100">
                   <li>Visit the Now Prepay Store.</li>
                </span>
                <span class="w-100">
                   <li>Inform the sales associate that you have an N2XGo transaction that is ready to pay.</li>
                </span>
                <span class="w-100">
                    <li>Pay the transaction amount of ${{ amount }} CAD. Please note that if the amount is not paid within 24 hours, your transfer will expire.</li>
                </span>
            </span>
            <span class="w-100 text-center py-1 pt-3">
                <strong>
                    A reminder to please carry this authorization number {{ sendMoneyService.qr_code }} or the QR code to the location. 
                    <!-- A quick reminder to bring your ID & Authorization No. {{ sendMoneyService.qr_code }} to the location. -->
                </strong>
            </span>
            <qr-code [value]="sendMoneyService.qr_code" size="300" errorCorrectionLevel="M" class="py-2"></qr-code>
            <div class="w-100 d-flex flex-column flex-md-row" style="height:500px" *ngIf="locations?.length">
                <div class="col-12 col-md-4 d-flex flex-wrap">
                    <div class="w-100 p-1 bg-light h-90" style="overflow-y: scroll;">
                        <div class="w-100 my-1 cursor-pointer text-left p-1" *ngFor="let location of locations" (click)="assignCoordinates(location.latitude, location.longitude, location)" [ngClass]="{'bg-pale-blue': location==selectedLocation}">
                            <h4>{{location.location_name}}</h4>
                            <h6>
                                {{location.address1}}<br />
                                {{location.town}}, {{location.prov_state}}<br />
                                {{location.postal_code}}
                            </h6>
                        </div>
                    </div>
                    <div class="w-100 d-flex justify-content-around h-fit-content my-1">
                        <button class="btn btn-primary" (click)="prevPage()" [disabled]="checkDisabled('prev')">
                            Previous
                        </button>
                        <button class="btn btn-primary" (click)="nextPage()" [disabled]="checkDisabled('next')">
                            Next
                        </button>
                    </div>
                </div>
                <div class="col-12 col-md-8">
                    <agm-map [latitude]="lat" [longitude]="lng">
                        <agm-marker 
                            *ngFor="let m of markers; let i = index"
                            [latitude]="m.lat"
                            [longitude]="m.lng"
                            [markerDraggable]="m.draggable"
                            (markerClick)="clickedMarker(infowindow)">
                            
                            <agm-info-window #infowindow>
                                <strong>{{m.title}}</strong>
                            </agm-info-window>
                            
                        </agm-marker>
                    </agm-map>
                </div>
            </div>
            <div class="w-100 d-flex align-items-center flex-wrap" *ngIf="!(locations?.length)">
                <div class="col-12 col-md-6">Please enter your postal code to search nearby locations : </div>
                <div class="col-12 col-md-6 d-flex justify-content-around align-items-center">
                    <input type="text" class="col-10 p-2" [(ngModel)]="postalCode">
                    <i class="fas fa-search border border-dark p-2 rounded cursor-pointer" (click)="getLocationByPostal()"></i>
                </div>
                <div class="text-center w-100" *ngIf="show">No locations found</div>
            </div>
        </div>
    </div>
</div>